var React = require('react');

function CollapseIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#606060","fillRule":"evenodd","d":"M8.219.32L.323 8.107c-.43.453-.43 1.147 0 1.573a1.147 1.147 0 001.59 0L9 2.666l7.087 7.014c.458.427 1.159.427 1.59 0 .43-.426.43-1.12 0-1.573L9.809.32c-.458-.427-1.16-.427-1.59 0z"}));
}

CollapseIconInline.defaultProps = {"width":"18","height":"10"};

module.exports = CollapseIconInline;

CollapseIconInline.default = CollapseIconInline;
